import React from 'react'
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazy-load'
// import MovieThumb from './MovieThumb.jpg'
import { Link } from 'react-router-dom'
import {CLIENT_BASE_URL} from '../../actions'

export class MovieItem extends React.Component {
  constructor (props) {
    super(props)
    this.getVideoUrl = this.getVideoUrl.bind(this)
    this.triggerClickTagName = this.triggerClickTagName.bind(this)
  }
  getThumbUrl (thumb) {
    return `${CLIENT_BASE_URL}${thumb}`
  }

  getVideoUrl (id) {
    if (this.props.type === 'movie') {
      return `/filme/${id}`
    }

    return `/actividade/${id}`
  }

  getMovieItemMainClass (highlight, grid_size) {
    // console.log('highlight', highlight)
    let clsname = 'col-sm-6 col-md-4 col-lg-4 movie-item'

    if (grid_size === 3) {
      clsname = 'col-sm-6 col-md-4 col-lg-4 movie-item'
    } else {
      clsname = 'col-sm-6 col-md-3 col-lg-3 movie-item'
    }

    if (highlight+'' === '1') {
      clsname += ' active'
    }

    return clsname
  }

  triggerClickTagName (e, tagname) {
    e.preventDefault()
    // e.stopPropagation()
    this.props.onClickTagLabel(tagname)
  }

  render () {
    const {grid_size, movie} = this.props

    return (
      <Link to={this.getVideoUrl(movie.id)}>
        <div className={this.getMovieItemMainClass(movie.highlight, grid_size)}>
          <div className='img-container'>
            <LazyLoad offsetHorizontal={1000} offsetVertical={300}>
              <img className='thumb' src={this.getThumbUrl(movie.thumb)} />
            </LazyLoad>
            <div className='thumb-ovr' />
          </div>
          <div className='details'>
            <p>{movie.title}</p>
            <p>{movie.keywords}</p>
            <p>{movie.logline}
            </p>
          </div>
          <div className='tags' onClick={(e) => this.triggerClickTagName(e, movie.name)}>
            <p>{movie.name}</p>
          </div>
        </div>
      </Link>
    )
  }
}

MovieItem.propTypes = {
  grid_size: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  movie: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    thumb: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    keywords: PropTypes.string.isRequired
  }).isRequired,
  onClickTagLabel: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/views/MoviesView/MovieItem.js